import React from 'react';
import ReactDOM from 'react-dom';
import './common';
import '@styles/apply.scss';
import InfluencerApplication from '@/InfluencerApplication';
import { Provider as StoreProvider } from "react-redux";

import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from "@reducers";

const store = createStore(reducer, applyMiddleware(thunk));


document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('React#influencer-application');
  form && ReactDOM.render(
    <StoreProvider store={store}>
      <InfluencerApplication />
    </StoreProvider>, form)
})